import axios from 'axios';

const getAddressFromCoordinates = async (latitude, longitude) => {
  const accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?access_token=${accessToken}&types=place,locality,region,country&language=en`;

  try {
    const response = await axios.get(url);
    const features = response.data.features;

    let city = '';
    let region = '';
    let country = '';
    let placeName = features[0]?.place_name || '';

    for (const feature of features) {
      if (!city && feature.place_type.includes('place')) {
        city = feature.text;
      }
      if (!region && feature.place_type.includes('region')) {
        region = feature.text;
      }
      if (!country && feature.place_type.includes('country')) {
        country = feature.text;
      }
    }

    return {
      city,
      region,
      country,
      placeName,
    };
  } catch (error) {
    console.error('Error fetching address from coordinates:', error);
    throw error;
  }
};

export default getAddressFromCoordinates;
